import { useIsMobile } from 'core/theme_deprecated/hooks';
import { useConfig } from './useConfig';

const horizontalGuttersPx = 32;
const defaultVideoWidth = 320;
const defaultVideoHeight = 424;

export const useScanSize = (video?: HTMLVideoElement | null) => {
  const { isMobile } = useIsMobile();
  const { palmPhotoLongSide, palmPhotoShortSide } = useConfig();

  if (video) {
    const videoElementWidth = video.getBoundingClientRect().width ?? defaultVideoWidth;
    const videoElementHeight = video.getBoundingClientRect().height ?? defaultVideoHeight;

    const adjustedWidth = video.getBoundingClientRect().width - horizontalGuttersPx;
    const originalAspectRatio = videoElementWidth / videoElementHeight;
    const adjustedHeight = adjustedWidth / originalAspectRatio;

    return {
      width: adjustedWidth,
      height: adjustedHeight,
    };
  }

  return {
    width: isMobile ? palmPhotoShortSide : palmPhotoLongSide,
    height: isMobile ? palmPhotoLongSide : palmPhotoShortSide,
  };
};
